module.exports = __webpack_public_path__ + "img/abtot-white.9a97b85d.svg";